import { confirmSignIn } from 'aws-amplify/auth';

import { AuthFlowError } from './auth-flow-error';

const challengeTarget = 'AWSCognitoIdentityProviderService.RespondToAuthChallenge';
const challengeTimeoutMs = 30_000;

const isChallengeSubmission = (init: RequestInit | undefined, answer: string): boolean => {
  if (
    new Headers(init?.headers).get('X-Amz-Target') !== challengeTarget ||
    typeof init?.body !== 'string'
  )
    return false;
  try {
    const request = JSON.parse(init.body);
    return (
      request?.ChallengeName === 'CUSTOM_CHALLENGE' && request.ChallengeResponses?.ANSWER === answer
    );
  } catch {
    return false;
  }
};

export const confirmCognitoChallengeOnce = async (challengeResponse: string) => {
  const transport = globalThis.fetch;
  let submitted = false;
  let cleanup: (() => void) | undefined;
  // Amplify 6 exposes no per-confirmSignIn retry limit. Guard only this custom challenge:
  // replaying a consumed Gamma proof after a lost response must require a fresh sign-in.
  const guarded: typeof fetch = (input, init) => {
    if (!isChallengeSubmission(init, challengeResponse)) return transport(input, init);
    if (submitted) return Promise.reject(new AuthFlowError('session-expired'));
    submitted = true;
    const controller = new AbortController();
    const abort = () => controller.abort();
    const source = init?.signal;
    const timeout = setTimeout(abort, challengeTimeoutMs);
    if (source?.aborted) abort();
    else source?.addEventListener('abort', abort, { once: true });
    cleanup = () => {
      clearTimeout(timeout);
      source?.removeEventListener('abort', abort);
    };
    return transport(input, { ...init, signal: controller.signal });
  };
  globalThis.fetch = guarded;
  try {
    return await confirmSignIn({ challengeResponse });
  } finally {
    cleanup?.();
    if (globalThis.fetch === guarded) globalThis.fetch = transport;
  }
};
